import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { crowdstrikeThrottleEnabled, crowdstrikeStoreFullMessage } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "crowdstrikeThrottleEnabled",
      defaultChecked: crowdstrikeThrottleEnabled == null ? void 0 : crowdstrikeThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "crowdstrikeStoreFullMessage",
      type: "checkbox",
      value: "enable-storeFullMessage",
      defaultChecked: crowdstrikeStoreFullMessage == null ? void 0 : crowdstrikeStoreFullMessage.value,
      onChange,
      label: "Store Full Message",
      help: "Store the full original CrowdStrike log record message as full_message?"
    }
  ));
};
export default FormAdvancedOptions;
